import { render, staticRenderFns } from "./Sunucu.vue?vue&type=template&id=791fcb06"
import script from "./Sunucu.vue?vue&type=script&lang=js"
export * from "./Sunucu.vue?vue&type=script&lang=js"
import style0 from "./Sunucu.vue?vue&type=style&index=0&id=791fcb06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports